<template>
  <div class="d-flex align-items-center gap-2 bg-body px-2 tooth-quantity-card"
       :class="{
          finished: appliedVsTotalStats?.status === 'finished' && !editMode
     }">
    <div class="font-weight-bold"
         v-if="isDentalClinic && !(showCheckboxInsteadOfClicker && editMode)">
      {{ tooth.teeth }}
    </div>
    <div v-if="appliedVsTotalStats && !editMode">
      {{ applied }} / {{ appliedVsTotalStats.qty }}
    </div>
    <template v-else>
      <PatientVisitToothServiceCheckboxClicker v-if="showCheckboxInsteadOfClicker"
                                               :minAmount="applied"
                                               :tooth="tooth.teeth"
                                               :serviceId="service.id"
                                               :readonly="readonly"/>
      <PatientVisitToothServiceQuantityClicker v-else
                                               :minAmount="applied"
                                               :tooth="tooth.teeth"
                                               :serviceId="service.id"
                                               :readonly="readonly"/>
    </template>

  </div>
</template>

<script setup>
import PatientVisitToothServiceQuantityClicker
  from "@/components/parts/patients/visit/teethTab/PatientVisitToothServiceQuantityClicker.vue"
import {computed, inject} from "vue"
import {useStore} from "vuex"
import {calculateAppliedVsTotalStats} from "@/services/teeth.helper"
import PatientVisitToothServiceCheckboxClicker
  from "@/components/parts/patients/visit/teethTab/PatientVisitToothServiceCheckboxClicker.vue"

const props = defineProps({
  tooth: {},
  readonly: Boolean,
  service: Object,
  view: {
    type: String,
    default: 'visit'
  }
})

const store = useStore()

const editMode = inject('editMode')

const visit = computed(() => store.state.patient.visit)
const isDentalClinic = computed(() => store.getters.isDentalClinic)

const appliedVsTotalStats = computed(() => {
  if(props.view !== 'planning') return null
  return calculateAppliedVsTotalStats(visit.value, [props.tooth], props.service.id)
})
const applied = computed(() => appliedVsTotalStats.value?.applied || 0)
// const showCheckboxInsteadOfClicker = computed(() => props.view === 'payment')
const showCheckboxInsteadOfClicker = computed(() => true)
</script>

<style scoped lang="scss">
.tooth-quantity-card {
  border-radius: 8px;
  height: 32px;
  &.finished {
    background: var(--bg-semantic-positive-light, #5E92461F);
    color: $green-color;
  }
}
@media screen and (max-width: 768px) {
  .tooth-quantity-card {
    height: 24px;
  }
}
</style>
